export var ResourceTypeApi;
(function (ResourceTypeApi) {
    ResourceTypeApi["USER"] = "user";
    ResourceTypeApi["PROJECT"] = "project";
    ResourceTypeApi["CONTEST"] = "contest";
})(ResourceTypeApi || (ResourceTypeApi = {}));
export var FieldTypeApi;
(function (FieldTypeApi) {
    FieldTypeApi["BOOLEAN"] = "boolean";
    FieldTypeApi["FLOAT"] = "float";
    FieldTypeApi["INTEGER"] = "integer";
    FieldTypeApi["TIMESTAMP"] = "timestamp";
    FieldTypeApi["POINT"] = "point";
    FieldTypeApi["VARCHAR_SMALL"] = "varchar_small";
    FieldTypeApi["OBJECT"] = "object";
})(FieldTypeApi || (FieldTypeApi = {}));
export const FieldTypeDBTableNameLookupApi = {
    [FieldTypeApi.BOOLEAN]: 'enterprise_resource_metadata_value_bool',
    [FieldTypeApi.FLOAT]: 'enterprise_resource_metadata_value_float',
    [FieldTypeApi.INTEGER]: 'enterprise_resource_metadata_value_integer',
    [FieldTypeApi.TIMESTAMP]: 'enterprise_resource_metadata_value_datetime',
    [FieldTypeApi.POINT]: 'enterprise_resource_metadata_value_point',
    [FieldTypeApi.VARCHAR_SMALL]: 'enterprise_resource_metadata_value_varchar',
    [FieldTypeApi.OBJECT]: 'enterprise_resource_metadata_object',
};
export const DBEnumFieldTypeLookupApi = {
    boolean: FieldTypeApi.BOOLEAN,
    float: FieldTypeApi.FLOAT,
    integer: FieldTypeApi.INTEGER,
    varchar: FieldTypeApi.VARCHAR_SMALL,
    datetime: FieldTypeApi.TIMESTAMP,
    point: FieldTypeApi.POINT,
    object: FieldTypeApi.OBJECT,
};
export const DBEnumResourceTypeLookupApi = {
    user: ResourceTypeApi.USER,
    project: ResourceTypeApi.PROJECT,
    contest: ResourceTypeApi.CONTEST,
};
export var CustomFieldFilterModifierApi;
(function (CustomFieldFilterModifierApi) {
    CustomFieldFilterModifierApi["EQUALS"] = "equals";
    CustomFieldFilterModifierApi["NOT_EQUALS"] = "not_equals";
    CustomFieldFilterModifierApi["GREATER_THAN"] = "greater_than";
    CustomFieldFilterModifierApi["GREATER_OR_EQUAL_THAN"] = "greater_or_equal_than";
    CustomFieldFilterModifierApi["LESS_THAN"] = "less_than";
    CustomFieldFilterModifierApi["LESS_OR_EQUAL_THAN"] = "less_or_equal_than";
    CustomFieldFilterModifierApi["IN"] = "in";
    CustomFieldFilterModifierApi["NOT_IN"] = "not_in";
})(CustomFieldFilterModifierApi || (CustomFieldFilterModifierApi = {}));
